<template>
    <div class='tbqd twoBox' v-if='tbdwmc'>
        <div class="redBox">
            <p class='red' v-if='!isBegin'>签到未开始</p>
            <div v-else>
                <p>签到剩余时间</p>
                <myClock class='small lf' :shenyu='shenyu' :key='shenyu' cId='c1'></myClock>
            </div>
        </div>
        <div class="box">
            <table class='show'>
                <colgroup width='160px'></colgroup>
                <tr>
                    <td>投标单位</td>
                    <td>{{tbdwmc}}</td>
                </tr>
                <tr>
                    <td>签到时间</td>
                    <td>
                        <span v-html="qdsj"></span>
                    </td>
                </tr>
            </table>
        </div>
        <!-- 签到弹窗 -->
        <el-dialog :visible.sync="visible" width="1100px" title="签到" :close-on-click-modal='false' v-if='visible'>
            <qdCom ref='qdCom' @Qd='caQd' @ewmQd='ewmQd'></qdCom>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../components/clock/clock'
import qdCom from '../components/qdCom'
export default {
    name:'tbqd',
    props:['djlcId'],
    components:{
        myClock,qdCom
    },
    data(){
        return{
            isBegin:true,
            shenyu:0,
            tbdwmc:'',
            qdsj:'',
            sfqd:false,//是否已签到
            visible:false,
            intervalTbqd:null,
            jgdm:'',
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId
            }
            this.$api.kbqdTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.isBegin=res.data.data.sfqd=='0'?false:true;//招标人是否开启签到
                    this.shenyu=res.data.data.djs;
                    if(res.data.data.tbdw){
                        this.tbdwmc=res.data.data.tbdw.fcqymc;
                        this.jgdm=res.data.data.tbdw.fcqyjgdm;
                        this.sfqd=res.data.data.tbdw.sfqd=='0'?false:true;//投标人是否已签到
                        if(this.shenyu>=1000){
                            if(this.sfqd){
                                this.qdsj=this.$moment(res.data.data.tbdw.qdsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qdsj='';
                                this.tbqdshenyuFun();
                            }
                        }else{
                            //签到倒计时结束
                            if(this.sfqd){
                                this.qdsj=this.$moment(res.data.data.tbdw.qdsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qdsj='<span class="red">未签到</span>'
                            }
                        }
                    }else{
                        this.tbdwmc=localStorage.getItem('user');
                        if(this.shenyu>=1000){
                            this.qdsj='';
                            this.tbqdshenyuFun();
                        }else{
                            //签到倒计时结束
                            this.qdsj='<span class="red">未签到</span>';
                            let obj={
                                lx:'tb',
                                data:{
                                    index:0,
                                    msg:'3',
                                    all:false
                                }
                            }
                            this.$emit('send',JSON.stringify(obj))
                            }
                    }
                    
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //投标人点击签到按钮操作
        tbrDo(lx){
            if(lx=='tbqd'){
                this.visible=true;
            }
        },
        //计算剩余时间倒计时
        tbqdshenyuFun(){
            var _this=this;
            var time=_this.shenyu
            clearInterval(_this.intervalTbqd);
            _this.intervalTbqd=null;
            _this.intervalTbqd=setInterval(function(){
                if(time<1000){
                    clearInterval(_this.intervalTbqd);
                     _this.intervalTbqd=null;
                    if(!_this.sfqd){
                        _this.qdsj='<span class="red">未签到</span>';
                        let obj={
                            lx:'tb',
                            data:{
                                index:0,
                                msg:'3',
                                all:false
                            }
                        }
                        _this.$emit('send',JSON.stringify(obj))
                    }
                    clearInterval(_this.intervalTbqd);
                     _this.intervalTbqd=null;
                    return;
                }
                time=time-2000;
            },2000)
        }, 
        //签到成功后关闭弹窗更新页面数据
        caQd(obj){ 
            this.$refs.qdCom.waitLoading = true
            let para={
                jgdm:obj.jgdm,
                caNo:obj.code,
                sftbr:true
            }
            this.$api.caQd(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        type:'success',
                        message:'签到成功！'
                    })
                    this.visible=false;
                    clearInterval(this.intervalTbqd);
                    this.intervalTbqd=null;
                    this.getData();
                    let obj={
                        lx:'tb',
                        data:{
                            index:0,
                            msg:'2',
                            all:true
                        }
                    }
                    this.$emit('send',JSON.stringify(obj));
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                 this.$refs.qdCom.waitLoading = false
            }).catch(()=>{

            })
        },
        //扫码签到
        ewmQd(e){
            this.$message({
                type:'success',
                message:"签到成功！"
            })
            this.visible=false;
            clearInterval(this.intervalTbqd);
            this.intervalTbqd=null;
            this.getData();
            let obj={
                lx:'tb',
                data:{
                    index:0,
                    msg:'2',
                    all:true
                }
            }
            this.$emit('send',JSON.stringify(obj));
        }, 
    },
    mounted(){
        this.getData();
    },
    beforeDestroy(){
        clearInterval(this.intervalTbqd);
        this.intervalTbqd=null;
    }
}
</script>
<style lang="less" scoped>
   
</style>